export const LIST_NAVIGATE = 'LIST_NAVIGATE';
export const OPTIONS_GET = 'OPTIONS_GET';
export const SETTINGS_GET = 'SETTINGS_GET';
export const SETTINGS_PUT = 'SETTINGS_PUT';
export const FIELDS_EDIT = 'FIELDS_EDIT';
export const COUNTERS_GET = 'COUNTERS_GET';
export const WEBTRACKING_INFOBOX_TOGGLE = 'WEBTRACKING_INFOBOX_TOGGLE';
